import blue from './blue.es.js';
import green from './green.es.js';
import orange from './orange.es.js';
import red from './red.es.js';
import violet from './violet.es.js';

/**
 * Chiclets Colors List.
 */ var variants = {
    green,
    blue,
    violet,
    orange,
    red
};

export { variants as default };
//# sourceMappingURL=index.es.js.map
